import { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import styles from './RegistrationDeposit.module.css';
import PayPalPayment from "../component/PayPalPayment"
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { loaduser } from "../actions/userAction";
import { useDispatch } from "react-redux";

import Arrow from '../component/Arrow.js';
import DollarBadge from '../images/registrationPaymentBadge.png';

export const RegistrationDeposit = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [depositAmount, setDepositAmount] = useState('');
    const [userData, setUserData] = useState(
        JSON.parse(localStorage.getItem("nftuser")??"")
    );
    const paypalOptions = useMemo(() => ({
        "client-id": process.env.REACT_APP_CLIENT_ID,
        currency: "USD",
        intent: "capture",
        "enable-funding": "venmo"
    }), []);
    const pull_data = async () => {
        dispatch(loaduser());
        setDepositAmount('');
        navigate("/SoloShowdown");
    }
    const handleCCButtonClick = (method) => {
        // Push GTM dataLayer event for analytics tracking
        window.dataLayer = window.dataLayer || [];  // ensure dataLayer array exists
        window.dataLayer.push({
        event: 'paypal_checkout_click',
        payment_method: method    // e.g. "paypal", "venmo", or "card"
        });
    };
    useEffect(() => {
        const storedUserData = localStorage.getItem("nftuser");
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
    }, []);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.contentContainer}>
                <h1 style={{
                    textAlign: "center",
                    color: "#FFFFFF",
                    fontSize: "24px",
                    marginBottom: "60px",
                }}>
                    Now Deposit Funds and Start Earning!
                </h1>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "50px" }}>
                    <div style={{
                        width: "100%",
                        textAlign: "center",
                        marginRight: "100px",
                    }}>
                        <p style={{
                            fontFamily: "Bungee",
                            fontSize: "12px",
                        }}>
                            ENTER <span style={{ fontFamily: "Bungee", color: "#1DCADC" }}>DEPOSIT</span> AMOUNT FIRST,<br />THEN PROCEED TO PAYPAL
                        </p>
                        <div style={{
                            fontFamily: "Bungee",
                            color: "#1DCADC",
                            fontSize: "30px",
                            marginBottom: "20px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "fit-content",
                            justifySelf: "center",
                            padding: "0 20px",
                            backgroundColor: "#CCCCCC1F",
                            borderRadius: "10px"
                        }}>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontFamily: "Bungee",
                            }}>
                                $
                                <input
                                    type="number"   
                                    value={depositAmount}
                                    onChange={(e) => setDepositAmount(e.target.value)}
                                    placeholder="0.00"
                                    className={styles.numberInput}
                                    style={{
                                        minWidth: "80px",
                                        width: `${Math.max(100, String(depositAmount).length * 25)}px`,
                                        padding: "10px",
                                        fontSize: "30px",
                                        fontFamily: "Bungee",
                                        textAlign: "left",
                                        color: "#1DCADC",
                                        marginBottom: "0",
                                        backgroundColor: "transparent",
                                        textOverflow: "clip",
                                        border: "none",
                                        outline: "none",
                                        transition: "width 0.2s cubic-bezier(0.4,0,0.2,1)",
                                    }}
                                />
                            </div>
                            <p style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                margin: "5px 0 10px 0",
                                color: "#8692A6"
                            }}>Available Funds: ${userData?.available_fund.toFixed(2)??"-"}</p>
                        </div>
                        <button style={{
                            width: "150px",
                            padding: "10px",
                            fontSize: "30px",
                            fontFamily: "Bungee",
                            textAlign: "center",
                            backgroundImage: "linear-gradient(30deg, #582C7F, #1DCADC)",
                            borderRadius: "10px",
                            border: "none",
                            cursor: "pointer",
                            margin: "5px 0 40px 0",
                        }}>
                            Deposit Funds
                        </button>
                        <PayPalScriptProvider options={paypalOptions}>
                            <PayPalPayment paymentMethod="paypal" money={depositAmount} userid={userData._id} func={pull_data} onButtonClick={() => handleCCButtonClick('paypal')} />
                            <PayPalPayment paymentMethod="venmo" money={depositAmount} userid={userData._id} func={pull_data} onButtonClick={() => handleCCButtonClick('venmo')} />
                            <PayPalPayment paymentMethod="creditcard" money={depositAmount} userid={userData._id} func={pull_data} onButtonClick={() => handleCCButtonClick('card')} />
                        </PayPalScriptProvider>
                    </div>
                    <div style={{
                        width: "100%",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        color: "#8692A6",
                        fontWeight: "500",
                        lineHeight: "3",
                    }}>
                        <img
                            src={DollarBadge}
                            alt="Deposit Payment Badge"
                            style={{
                                width: "200px",
                                marginBottom: "16px",
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto"
                            }}
                        />
                        <p>💸 Start Earning From The Games You Already Play</p>
                        <p>🚀 Instantly Challenge Players for Real Money</p>
                        <p>🔒 Instant payouts via PayPal or Venmo</p>
                    </div>
                </div>

                <span style={{ 
                    whiteSpace: "nowrap", 
                    color: "#8692A6", 
                    fontWeight: "500", 
                    textAlign: "center", 
                    marginTop: "20px", 
                    fontSize: "16px" 
                }}>
                    <span style={{ color: "#66FF66" }}>
                        Account Created
                    </span>
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    <span style={{ color: "#66FF66" }}>
                        Link Overwolf
                    </span>
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    <span style={{ color: "#66FF66" }}>
                        Download Validator</span>
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    <span>
                        Deposit Funds
                    </span>
                </span>
            </div>
        </div>
    );
};
